import type { Timestamp } from 'firebase/firestore';

export function formatTimestamp(ts: Timestamp | { seconds: number } | undefined | null): string {
  if (!ts) return '—';
  const date =
    'toDate' in ts && typeof ts.toDate === 'function'
      ? ts.toDate()
      : new Date(('seconds' in ts ? ts.seconds : 0) * 1000);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatCents(cents: number | undefined | null): string {
  if (cents == null) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function categoryLabel(slug: string): string {
  return slug
    .split('_')
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}
